import { Box, Button, H1, PancakeStack, Sheet } from '@betterment/samba-react';

interface ActivityDrawerLayoutProps {
  title: string;
}

export const ActivityDrawerLayout: React.FC<React.PropsWithChildren<ActivityDrawerLayoutProps>> = ({
  title,
  children,
}) => {
  return (
    <PancakeStack css={{ px: 'space.400', pt: 'space.400' }}>
      <PancakeStack.Header>
        <Sheet.Title asChild={true}>
          <H1 variant="title300">{title}</H1>
        </Sheet.Title>
      </PancakeStack.Header>
      <PancakeStack.Main css={{ pt: 'space.200', pb: 'space.800' }}>{children}</PancakeStack.Main>
      <PancakeStack.Footer
        css={{
          borderColor: 'border',
          borderTop: 'solid 1px',
          pb: 'space.200',
          py: 'space.200',
        }}
      >
        <Sheet.Trigger asChild={true}>
          <Box>
            <Button variant="solidSecondary">Close</Button>
          </Box>
        </Sheet.Trigger>
      </PancakeStack.Footer>
    </PancakeStack>
  );
};
